import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CasinoGamesSection from "../../../components/casinoGamesSection";
import BackIcon from "../../../../assets/svg/BackIcon";
import SearchIcon from "../../../../assets/svg/SearchIcon";

const Casino = () => {
  const categoriesTab = [
    { name: "Improved Experience", key: "improvedExperience" },
    { name: "Card Games", key: "cardGames" },
    { name: "Virtual Card Games", key: "virtualCardGames" },
    { name: "Instant Games", key: "instantGames" },
  ];
  const [activeCategory, setActiveCategory] = useState("improvedExperience");
  const [filteredData, setFilteredData] = useState([]);
  const [isSearched, setIsSearched] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <main className="main">
        <div className="GameHeader">
          <div className="backBtn" onClick={() => navigate(-1)}>
            <BackIcon />
          </div>
          <h4>Game</h4>
          <div className="SearchBar">
            <SearchIcon />
          </div>
        </div>
        <div className="container-fluid">
          <CasinoGamesSection />
        </div>
      </main>
    </>
  );
};

export default Casino;
